import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { vendorBroadcastQueries } from '../api/vendor-broadcast-queries';
import type { VendorBroadcastStatus } from './schema';

/**
 * The vendor's broadcasts, optionally filtered to one status (the fresh-items
 * dialog passes `'fresh'`). Keyed by the UI language: the backend resolves
 * title/message per `Accept-Language`, so a language switch must refetch
 * rather than keep serving the cached locale's text.
 */
export function useVendorBroadcasts(status?: VendorBroadcastStatus) {
  const { i18n } = useTranslation();
  return useQuery(vendorBroadcastQueries.list(status ?? 'all', i18n.language));
}

/** Badge count: fresh items plus viewed ones still awaiting a response. */
export function useUnreadBroadcastCount() {
  return useQuery(vendorBroadcastQueries.unreadCount());
}
